var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img",style:(_vm.divStyle)},[_c('img',{ref:"canvas"})])
}
var staticRenderFns = []

export { render, staticRenderFns }